/** True for `{}`-shaped values only — arrays and `null` are objects too, and neither spreads sanely. */
export function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
